import { Company, CompanyId, CompanyTitle, CompanySubscription } from '@/models/companies'
import api from './api'
import { DataTableResponse } from '@/models/scripts'

class CompaniesApiService {
  static getInstance(): CompaniesApiService {
    return this.instance || (this.instance = new this())
  }

  private static instance: CompaniesApiService

  private baseUrl = '/companies/'

  private constructor() {
    // empty for linter
  }

  get() {
    return api.get<Company[]>(this.baseUrl)
  }

  create(title: string) {
    const payload: CompanyTitle = {
      title,
    }
    return api.post<CompanyId>(`${this.baseUrl}create`, payload)
  }

  update(id: string, title: string) {
    const payload: CompanyTitle = {
      title,
    }
    return api.post<boolean>(`${this.baseUrl}${id}`, payload)
  }

  delete(id: string) {
    return api.delete<boolean>(`${this.baseUrl}${id}`)
  }

  activate(id: string) {
    return api.put<boolean>(`${this.baseUrl}${id}/use`)
  }

  subscription(id: string) {
    return api.get<CompanySubscription>(`${this.baseUrl}${id}/subscription`)
  }

  getOrders(
    limit: number,
    offset: number,
    expand: string,
    sort: string,
    filter: string,
    companyId: number
  ) {
    let expandWithId = expand
    if (!expand.split(',').includes('id') && Object.keys(expand).length !== 0) {
      const arr = expand.split(',')
      arr.unshift('id')
      expandWithId = arr.join()
    }
    const url = `${this.baseUrl}/${companyId}/orders?expand=${expandWithId}&offset=${offset}&limit=${limit}&sort=${sort}&filter=${filter}`
    return api.get<DataTableResponse>(url)
  }
}

export default CompaniesApiService.getInstance()
